// BEUS-11496 M3: `/v2/heatmap/scroll` 응답 -> 기존 dream-api `/es/get_scroll` 응답 모양.
// 화면의 normalizeScrollData(report-data-normalizer.js)를 고치지 않고 그대로 쓰기 위한 변환이다.
//
// 기존 응답(es_response_helper.reform_scroll_response):
//   scroll: { '0.0': r0, '0.01': r1, ... '0.99': r99 }  ES percentile_ranks(HDR) = scroll <= i/100 인 문서 비율(%)
//   count: Scroll 문서 수, attention: 100구간 값 / 최댓값, max_attention: 최댓값, docHeight: {max, min}, fold
// v2 값은 정확값이다: reachedDocuments[i] = scroll > i/100 문서 수 -> rank = 100 x (1 - reached / 분모).
//
// mode
//   'on'        분모 = Scroll 문서 수(기존 화면과 같은 의미). 10/16 P0 D6 확정으로 기본값. (10/21 전 이름 'legacy')
//   'pageViews' 분모 = 같은 조건 Visit PV(10/7 임시안, 10/16 보류. 비교용). Scroll 문서가 PV보다 많으면(recon 이벤트)
//               도달률이 1을 넘을 수 있어 화면 표시값은 0~100%로 자른다(clamped 표시는 meta에 남김).
// docHeight: 기존은 Scroll 문서 docHeight의 ES percentiles [0, 100](= 최솟값·최댓값)을 int()로 자르고, 값이 없으면 {0, 0}.
//   v2 observedDocumentHeightMinPx·MaxPx(정확한 최솟값·최댓값)를 같은 규칙으로 바꾼다. 화면 scroll tip(max - min)이 쓴다.

// Python int()처럼 0 쪽으로 자른다(docHeight는 양수).
function legacyInt (v) {
  return Math.trunc(v)
}

export function toLegacyDocHeight (result) {
  const min = result.observedDocumentHeightMinPx
  const max = result.observedDocumentHeightMaxPx
  if (min === null || min === undefined || max === null || max === undefined) return { max: 0, min: 0 }
  return { max: legacyInt(max), min: legacyInt(min) }
}

function key (i) {
  return i === 0 ? '0.0' : String(i / 100)
}

// fold: `/v2/heatmap/scroll/fold` 결과의 fold(기존 /es/get_scroll의 fold와 같은 모양). 오른쪽 Scroll Statistics 패널이
//   fold.aboveSize 등을 읽으므로 빠지면 패널 전체가 그려지지 않는다(10/8 로컬 화면 비교에서 발견).
export function toLegacyScroll (result, mode = 'on', fold = null) {
  const sections = result.sections || []
  // 'pageViews'만 Visit PV 분모, 나머지('on')는 기존 분모.
  const denominator = mode === 'pageViews' ? result.pageViews : result.scrollDocuments
  const scroll = {}
  let clamped = 0
  for (let i = 0; i < 100; i++) {
    const reached = sections[i] ? sections[i].reachedDocuments : 0
    let rate = denominator ? reached / denominator : 0
    if (rate > 1) {
      rate = 1
      clamped += 1
    }
    scroll[key(i)] = denominator ? 100 * (1 - rate) : 0
  }
  const scores = sections.map(s => s.attentionScore)
  const maxAttention = scores.length ? Math.max(...scores) : 0
  const out = {
    scroll,
    count: denominator || 0,
    attention: sections.map(s => (maxAttention ? s.attentionScore / maxAttention : 0)),
    max_attention: maxAttention,
    docHeight: toLegacyDocHeight(result),
    _v2: {
      mode,
      dataVersion: result.dataVersion,
      watermarkAt: result.watermarkAt,
      scrollDocuments: result.scrollDocuments,
      pageViews: result.pageViews,
      clampedSections: clamped,
      avgViewportHeightPx: result.avgViewportHeightPx
    }
  }
  if (fold) out.fold = fold
  if (out.attention.length !== 100) out.attention = new Array(100).fill(0)
  return out
}
